import { render, staticRenderFns } from "./ChatAtBox.vue?vue&type=template&id=bb44b6e0&scoped=true"
import script from "./ChatAtBox.vue?vue&type=script&lang=js"
export * from "./ChatAtBox.vue?vue&type=script&lang=js"
import style0 from "./ChatAtBox.vue?vue&type=style&index=0&id=bb44b6e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb44b6e0",
  null
  
)

export default component.exports